import styled, { css } from "styled-components";

import { motion } from "framer-motion";
import animations from "../../../utils/animation";

export const Container = styled(motion.div).attrs(animations)`
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f1f1f1;
  overflow: auto;
`;

export const DivLogo = styled.div`
  position: absolute;
  top: 20px;
  left: 20px;

  @media (max-width: 1024px) {
    display: none;
  }
`;

export const Logo = styled.img`
  width: 200px;
`;

export const Main = styled.div`
  min-width: 700px;
  width: 45%;
  min-height: 85%;
  display: flex;
  align-items: center;
  flex-direction: column;

  @media (max-width: 1024px) {
    width: 100%;
    min-width: 100%;
  }
`;

export const Titles = styled.div`
  width: 100%;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  margin: ${(props) => props.margin || 0};

  @media (max-width: 1024px) {
    width: 80%;
    align-items: center;
    text-align: center;
  }
`;

export const Title = styled.h2`
  margin-bottom: 5px;
  font-size: 18px;
`;

export const SubTitle = styled.p`
  color: #707070;
`;

export const Question = styled.div`
  box-shadow: 0px 0px 9px 0px rgba(150, 150, 150, 0.4);
  width: 628px;
  height: 293px;
  background: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin: 30px 0 0;

  @media (max-width: 1024px) {
    width: 80%;
    height: 390px;
  }
`;

export const QuestionTitle = styled.p`
  text-align: left;
  line-height: 1.5;
  font-size: 16px;
  color: #707070;
  width: 400px;

  @media (max-width: 1024px) {
    text-align: center;
    width: 80%;
  }
`;

export const QuestionOptions = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  width: 60%;
  margin: 20px 0;

  @media (max-width: 1024px) {
    flex-direction: column;
  }
`;

export const Option = styled.div`
  cursor: pointer;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  margin: 0 20px 0 0;

  input {
    width: 1.3em;
    height: 1.3em;
    background-color: white;
    border-radius: 50%;
    vertical-align: middle;
    border: 1px solid #ddd;
    -webkit-appearance: none;
    outline: none;
    cursor: pointer;
  }

  @media (max-width: 1024px) {
    margin: 20px 0;
  }
`;

export const Buttons = styled.div`
  min-width: 60%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-around;
  align-items: center;
  margin: 20px 0 0;
`;

export const Button = styled.button`
  min-width: 230px;
  height: 40px;
  border-radius: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 10px;
  font-size: 12px;

  ${(props) => props.contained && contained}
  ${(props) => props.outline && outline}

  @media (max-width: 1024px) {
    margin: 10px 20px;
    min-width: 230px;
  }
`;

const contained = css`
  background: #2196f3;
  color: #fff;
`;

const outline = css`
  border: 1px solid #2196f3;
  color: #2196f3;
`;

export const Infos = styled.div`
  box-shadow: 0px 0px 9px 0px rgba(150, 150, 150, 0.4);
  min-width: 628px;
  min-height: 450px;
  background: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin: 30px 0 0;
  padding: 30px;
  line-height: 1.5;

  @media (max-width: 1024px) {
    margin: 0;
    padding: 80px 0 0;
    min-width: 100%;
    width: 100%;
    min-height: 100vh;
  }
`;

export const Texts = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  p {
    color: #909090;
    width: 500px;
  }

  ul {
    width: 450px;
    margin: 30px 0;
  }

  li {
    color: #707070;
  }

  @media (max-width: 1024px) {
    width: 80%;

    p {
      width: 80%;
    }

    ul {
      width: 80%;
    }
  }
`;

export const UlCustom = styled.div`
  max-width: 50%;
  list-style: none;

  li {
    margin: 10px 0;
  }

  @media (max-width: 1024px) {
    max-width: 90%;
  }
`;
